import { combineReducers } from '@reduxjs/toolkit';

import { createPointsGroupReducer } from 'application/pages/PointsGroupsPage/renderer/slices/createPointsGroup/slice';

import { applicationReducer } from './applicationSlice';
import { acceptanceAdvancedReducer } from './acceptanceAdvancedSlice';
import { globalPollingReducer } from './globalPollingSlice';
import { accountReducer } from './accountSlice';
import { featureFlagsReducer } from './featureFlagsSlice';

const rootReducer = combineReducers({
  application: applicationReducer,
  acceptanceAdvanced: acceptanceAdvancedReducer,
  account: accountReducer,
  featureFlags: featureFlagsReducer,
  globalPolling: globalPollingReducer,
  createPointsGroup: createPointsGroupReducer,
});

export default rootReducer;

export * from './applicationSlice/selectors';
export * from './applicationSlice/slice';

export * from './acceptanceAdvancedSlice/selectors';
export * from './acceptanceAdvancedSlice/slice';

export * from './accountSlice/selectors';
export * from './accountSlice/dataSelectors';
export * from './accountSlice/slice';
export * from './accountSlice/thunks';

export * from './featureFlagsSlice/slice';
export * from './featureFlagsSlice/thunks';
export * from './featureFlagsSlice/selectors';

export * from './globalPollingSlice/slice';
